/* === AgSkeleton — Anagogia Design System === */

import styles from './AgSkeleton.module.css';

export interface AgSkeletonProps {
  variant?: 'text' | 'rectangular' | 'circular' | 'rounded';
  width?: number | string;
  height?: number | string;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Placeholder de chargement animé (texte, rectangle, cercle).
 * @category Feedback
 */
function AgSkeleton({
  variant = 'text',
  width,
  height,
  className,
  style,
}: AgSkeletonProps) {
  const cls = [styles.skeleton, styles[variant], className].filter(Boolean).join(' ');

  return (
    <span
      className={cls}
      style={{
        width: width ?? (variant === 'circular' ? height : '100%'),
        height: height ?? (variant === 'text' ? undefined : 40),
        ...style,
      }}
      aria-hidden="true"
    />
  );
}

export { AgSkeleton };
export default AgSkeleton;
